export default "__VITE_ASSET__Boqaza9m__"